export const TRIGGER_TYPE_STATIC_CART = "STATIC_CART";
export const TRIGGER_TYPE_DYNAMIC_TEXT = "DYNAMIC_TEXT";
